/**
 * Readies a sender's HTML for the message frame or the print window. It is parsed here, where
 * nothing loads, and loses what the browser would act on as soon as the email shows:
 * - <link> and <meta>: a resource hint (preconnect, dns-prefetch) reaches the sender's host even
 *   with remote images blocked, telling them when the mail was opened and from where, and a
 *   <meta> can refresh the page or loosen its referrer policy.
 * - window.opener: every link opens without it, so the page it opens can't send the Cloudmail
 *   tab elsewhere (a sender's rel="opener", or a named target, would hand it over).
 * Returns the head and the body, so the sender's styles still apply.
 */
export const defuseHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  for (const element of doc.querySelectorAll("link, meta")) element.remove();
  for (const link of doc.querySelectorAll("a, area"))
    link.setAttribute("rel", "noopener noreferrer");
  return doc.documentElement.innerHTML;
};

/** Turns off the browser's own DNS prefetching of link hosts, for the frame and print window. */
export const NO_DNS_PREFETCH = '<meta http-equiv="x-dns-prefetch-control" content="off">';
